import React from 'react';
import ValidateInstructorQualificationsModal from '../../../Common/ValidationModals/ValidateInstructorQualificationsModal';

interface EditDeliveryDetailsQualificationsModalProps {
    visible: boolean;
    onCancel: any;
    onConfirm: any;
    instructorConflict: any;
    formValues: any;
    missingQualifications: Array<string> | null;
}

const EditDeliveryDetailsQualificationsModal = (
    props: EditDeliveryDetailsQualificationsModalProps,
) => (
    <ValidateInstructorQualificationsModal
        {...props}
        headerText="Instructor conflict"
        confirmButtonText="Yes, continue"
    />
);

export default EditDeliveryDetailsQualificationsModal;
